module.exports = __webpack_public_path__ + "static/media/21ECLAC20.899818dd.jpg";